<template>
  <div class="pt-3">
    <b-row align-h="between" no-gutters="">
      <b-col cols="3" sm="2">
        <b-row class="pr-3" align-h="between" no-gutters="">
          <i id="stacked" :class="computedSelectColor" class="stacked icons">
            <i id="circle" class="circle icon m-auto" />
            <i id="outline" class="circle outline icon" />
          </i>
        </b-row>
      </b-col>
      <b-col class="d-none d-sm-block pr-4" sm="5">
        <b-row align-h="between" no-gutters="">
          {{ historyLog.raison }}
        </b-row>
      </b-col>
      <b-col cols="3" sm="2">
        <b-row class="pr-3" align-h="between" no-gutters="">
          {{ historyLog.cpu }}%
        </b-row>
      </b-col>
      <b-col cols="6" sm="3">
        <b-row align-h="between" no-gutters="">
          {{ historyLog.created_at }}
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/**
 * @description Affiche les informations de base d'un historique de log de logiciel
 * @author Samuel Colassin
 * @vue-prop {Object} historyLog - Le statut du logiciel lorsque le log a été enregistré
 * @vue-computed {String} computedSelectColor - Détermine la couleur du statut du logiciel
 */
export default {
  name: "SoftwareLogHistory",
  props: {
    historyLog: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedSelectColor() {
      return this.historyLog.etat_courant == 2
        ? "text-danger"
        : this.historyLog.etat_courant == 1
        ? "text-warning"
        : this.historyLog.etat_courant == 0
        ? "text-success"
        : "text-light";
    }
  }
};
</script>

<style scoped>
#circle {
  font-size: 16px;
}

#outline {
  font-size: 24px;
}

#stacked {
  margin-left: 5px;
}
</style>
